import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchList, fetchUsers, downloadList } from 'store/actions/index';
import { parseUserData } from 'store/reducers/list';
import { Button, message } from 'antd';
import Spinner from 'components/UI/Spinner/Spinner';
import WithError from 'HOC/Error/WithError';
import { axiosCms } from 'Axios.js';
import * as html2pdf from 'html2pdf.js';
import moment from 'moment';
import ListSearch from 'components/List/ListSearch';
import ErrorCard from 'components/UI/Error/ErrorCard';
import ListDisplay from 'components/List/ListDisplay';
import * as Page from 'HOC/Layout/PageContainer';
import styles from './ListPage.module.css';

const { Container, Title } = Page;

class ListPage extends Component {
  state = {
    error: false,
    HFID: '',
  };

  componentWillMount() {
    this.setState(prevState => ({ ...prevState, error: false, HFID: '' }));
  }

  // renderAsync displays a Spinner or Error if async call fails
  renderAsync = () => (this.state.error ? <ErrorCard HFID={this.state.HFID} /> : <Spinner />);

  renderList = () => {
    const { parsedList, isLoading } = this.props;
    if (parsedList) return <ListDisplay list={parsedList} isLoading={isLoading} />;
    else return null;
  };

  onSearchHandler = (id, HFID, form) => {
    const { fetchUsers } = this.props;
    return this.props
      .fetchList(id)
      .then(resp => {
        const {
          data: { list },
        } = resp;
        this.setState(prev => ({ ...prev, error: false, HFID: list.uuid }));
        return fetchUsers();
      })
      .then(resp => {
        form.resetFields();
        message.success('List loaded');
      })
      .catch(err => {
        this.setState(prev => ({ ...prev, error: true }));
      });
  };

  onDownloadHandler = id => {
    const hide = message.loading('Downloading in progress..', 0);
    const { HFID } = this.state;
    this.props
      .downloadList(id)
      .then(data => {
        let reader = new FileReader();
        reader.onload = e => {
          const link = document.createElement('a');
          link.setAttribute('download', `HAFARY_${HFID}_${moment().format('HHMM')}.pdf`);
          const URL = e.target.result;
          link.href = URL;
          link.click();
        };
        reader.readAsDataURL(new Blob([data]));
        hide();
      })
      .catch(err => {
        hide();
        console.log(err);
        message.error('Download failed');
      });
  };

  renderContainer = () => {
    const { parsedList, isLoading } = this.props;
    return (
      <Container type="2x3">
        <Title title="List" />
        <div className={styles.Main}>
          <ListSearch onSearchHandler={this.onSearchHandler} />
          <Button
            disabled={!parsedList}
            size="large"
            type="primary"
            style={{ float: 'right' }}
            onClick={() => this.onDownloadHandler(parsedList.id)}
          >
            Download
          </Button>
          <div style={{ clear: 'both' }}></div>
          <hr style={{ marginTop: 20 }} />
          {isLoading ? this.renderAsync() : this.renderList()}
        </div>
        <div id="list_show_pdf"></div>
      </Container>
    );
  };

  render() {
    return this.renderContainer();
  }
}

const mapStateToProps = state => {
  const { list } = state.list;
  const isLoading = state.list.loading;
  // parsedList changes the user_id to actual user data
  const parsedList = parseUserData(list);
  return {
    parsedList,
    isLoading,
  };
};

const mapDispatchToProps = { fetchList, fetchUsers, downloadList };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithError(ListPage, axiosCms));



// WEBPACK FOOTER //
// ./src/containers/List/ListPage.js